import { getUserData } from 'queries/ossix/user/userData';
import { useEffect, useState } from 'react';
import socketIOClient from './socketIO';
import { useStatus } from 'hooks/useStatusProvider';
import { useUpdateConfirmModal } from 'hooks/useConfirmModal';
import { useExecOp } from 'Contexts/ExecOpContext';

const OPERATION_FAILED = 'OperationFailed';

export default () => {
  const { userData } = getUserData();
  const { setExecOpInProgress } = useExecOp();
  const { setUpdateStatus, setProps } = useUpdateConfirmModal();
  const { status, setStatus } = useStatus();
  const [message, setMessage] = useState<string>('');

  const data = userData?.[0];

  const onHandleUpdateStatus = () => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      isCanceled: true,
      isPending: false,
      isSuccess: false,
    }));
  };

  useEffect(() => {
    if (data && data.PID) {
      socketIOClient.off(OPERATION_FAILED);
      socketIOClient.on(OPERATION_FAILED, (notification) => {
        const { message } = notification || {};

        onHandleUpdateStatus();
        setMessage(message);
        setExecOpInProgress(false);
        localStorage.removeItem('opExInProgress');
      });
    }

    return () => {
      socketIOClient.off(OPERATION_FAILED);
    };
  }, [data && data.PID]);

  useEffect(() => {
    if (status.isCanceled) {
      setUpdateStatus({
        isCanceled: true,
        isPending: false,
        isSuccess: false,
        closePending: true,
      });
      setProps({ message: message });
    }
  }, [status]);

  return null;
};
